import CustomTableList from "./CustomTableList";

const CustomTableListWithDetails = ({
    props,
    data,
    renderHeader,
    renderDetails,
    children
}) => {
    //#region Functions
    const renderTableListItem = index => {
        const currentItemIndex = Math.floor(index/2);
        const currentItem = data[currentItemIndex];
        if (index % 2 !== 0) {
            return renderDetails(currentItem, index, currentItemIndex);
        }
        return renderHeader(currentItem, index, currentItemIndex);
    }
    const getIterations = () => Array(data.length*2).fill();
    //#endregion
    return (
        <CustomTableList {...props}>
            {data 
            ? getIterations().map((_, index) => renderTableListItem(index))
            : children}
        </CustomTableList>
    )
}

export default CustomTableListWithDetails;